import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.customerTypes.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.customerTypes.actionsLoading;
export const getItems = (state:RootState) => state.customerTypes.items;
export const getItemsSelect = (state:RootState) => state.customerTypes.dropDownItems;
export const getItemsCount = (state:RootState) => state.customerTypes.itemsCount;
export const getItemForEdit = (state:RootState) => state.customerTypes.itemForEdit;
export const getError = (state:RootState) => state.customerTypes.error;
export const getErrorAction = (state:RootState) => state.customerTypes.errorAction;
export const validationErrors = (state: RootState) => state.customerTypes.validationErrors;
